/**
 * Componente de Estado de Carregamento Padronizado
 * 
 * @author Equipe GestaoeCRM
 * @date 19/12/2025
 */

import LoadingSpinner from './LoadingSpinner';
import { cn } from '@/utils/cn';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  className?: string;
  variant?: 'default' | 'skeleton';
  skeletonLines?: number;
}

export default function LoadingState({
  message = 'Carregando...',
  size = 'md',
  fullScreen = false,
  className,
  variant = 'default',
  skeletonLines = 3,
}: LoadingStateProps) {
  if (variant === 'skeleton') {
    return (
      <div
        className={cn(
          'space-y-4',
          fullScreen && 'min-h-screen flex flex-col justify-center',
          className
        )}
      >
        {Array.from({ length: skeletonLines }).map((_, index) => (
          <div
            key={index}
            className="h-4 bg-background-glass rounded animate-pulse"
            style={{
              width: `${100 - index * 10}%`,
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        fullScreen ? 'min-h-screen' : 'py-12',
        className
      )}
    >
      <LoadingSpinner size={size} />
      {message && (
        <p className="mt-4 text-sm text-text-secondary">{message}</p>
      )}
    </div>
  );
}

